export default class Header {

  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        windowWidth: window.innerWidth,
        $announcementSlides: $('.js-announcement-slide'),
        announcementTiming: $('.js-announcement-slideshow').data('timing') || 4,
        hasHeaderSearchResults: !!document.querySelector('.js-header-search-form'),
        hasIntroAnimation: false,
        currentSearch: '',
        searchKeysPressed: 0,
        pageCount: 0
      };

      this.checkForValidAnimation();
      this.reset();
      this.updateHeaderPadding();

      if (this.state.hasIntroAnimation) {
        this.setupAnimation();
      }

      this.runAnnouncementSlideshow();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Starts the announcement bar slideshow
  //===========================================================================

  runAnnouncementSlideshow() {
    const $slides = this.state.$announcementSlides;

    if ($slides.length > 1) {
      const timing = Number(this.state.announcementTiming) * 1000 || 4000;
      let nextSlide = 0;

      for (let i = 0; i < $slides.length; i++) {
        const $slide = $($slides[i]);

        if ($slide.hasClass('active') && i < ($slides.length - 1)) {
          nextSlide = i + 1;
          break;
        }
      }

      setTimeout(() => {
        if ($slides[nextSlide]) {
          $slides.removeClass('active');
          $slides[nextSlide].classList.add('active');
          this.runAnnouncementSlideshow();
        }
      }, timing);
    }
  }

  //===========================================================================
  // Sets/Resets the header
  //===========================================================================

  reset() {
    if (this.state.pageCount > 0 && this.state.hasIntroAnimation) {
      this.removeIntroAnimation();
    }

    $('.js-header-search').removeClass('active');
    this.state.pageCount += 1;
    this.adjustHeaderOnScroll();

    setTimeout(() => {
      this.resetSearch();
    }, 2000);
  }

  //===========================================================================
  // Updates header padding on screen resize.
  //===========================================================================

  updateHeaderPaddingOnResize() {
    const windowWidth = window.innerWidth;

    if (windowWidth !== this.state.windowWidth) {
      this.updateHeaderPadding;
      this.state.windowWidth = windowWidth;
    }
  }

  //===========================================================================
  // Updates the site top padding so that the fixed header doesn't
  // cover any website content.
  //===========================================================================

  updateHeaderPadding() {
    const $body = $('body');
    const $header = $body.find('.js-header');
    const $logoText = $header.find('.js-header-logo-text');
    const $headerPadding = $('.js-header-padding');
    const $inversePadding = $('.js-header-padding-inverse');

    if (!$body.hasClass('animation-hold')) {
      $headerPadding.each((i, hp) => {
        const $hp = $(hp);

        if ($hp.hasClass('reduced')) {
          $hp.css({ paddingTop: `${ $header[0].offsetHeight - $logoText[0].offsetHeight }px` });
        } else {
          $hp.css({ paddingTop: `${ $header[0].offsetHeight }px` });
        }
      });

      $inversePadding.each((i, hp) => {
        const $hp = $(hp);

        if ($hp.hasClass('reduced')) {
          $hp.css({ marginTop: `-${ $header[0].offsetHeight - $logoText[0].offsetHeight }px` });
        } else {
          $hp.css({ marginTop: `-${ $header[0].offsetHeight }px` });
        }
      });
    }
  }

  //===========================================================================
  // Adjusts the homepage header style on scroll
  //===========================================================================

  adjustHeaderOnScroll() {
    const $body = $('body');

    if (window.scrollY > 50) {
      $body.removeClass('scroll-at-top');
    } else {
      $body.addClass('scroll-at-top');
    }
  }

  //===========================================================================
  // Toggles the mobile nav menu on hamburger click
  //===========================================================================

  toggleMobileMenu() {
    const $body = $('body');

    if ($body.hasClass('mobile-nav-active')) {
      $body.removeClass('mobile-nav-active');
    } else {
      $body.removeClass('cart-drawer-active');
      $body.removeClass('account-drawer-active');
      $body.addClass('mobile-nav-active');
    }
  }

  //===========================================================================
  // When someone clicks the search icon
  //===========================================================================

  onHeaderSearchClick(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-header-search');
    const $body = $('body');

    e.preventDefault();

    if ($body.hasClass('template-search')) {
      $('html').animate({
        scrollTop: 0
      }, 'slow', () => {
        $('.js-search-page-input').focus();
      });
    } else {
      $parent.toggleClass('active');
    }
  }

  //===========================================================================
  // Holds the search bar open if input is in focus
  //===========================================================================

  toggleSearchHoldOpen(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-header-search');

    if (e.type === 'focusin') {
      $parent.addClass('active');
    } else {
      setTimeout(() => {
        if (!$parent.find('input:focus, button:focus').length) {
          $parent.removeClass('active');
        }
      }, 200);
    }
  }

  //===========================================================================
  // Submits header search form
  //===========================================================================

  searchSubmit(e) {
    const $form = $(e.currentTarget).closest('form');
    const keyD = e.key !== undefined ? e.key : e.keyCode;

    if (keyD === 'Enter' || keyD === 13) {
      $form.submit();
    }
  }

  //===========================================================================
  // Gets search results for the header search window
  //===========================================================================

  getSearchResultsOnInput(e) {
    const $input = $(e.currentTarget);
    const $form = $input.closest('form');
    const keyD = e.key !== undefined ? e.key : e.keyCode;

    if (keyD !== 'Enter' && keyD !== 13) {
      this.state.searchKeysPressed += 1;

      setTimeout(() => {
        this.state.searchKeysPressed -= 1;

        if (this.state.searchKeysPressed <= 0 && this.state.currentSearch !== $input.val()) {
          $form.submit();
        }
      }, 500);
    }
  }

  //===========================================================================
  // Gets search results for the header search window
  //===========================================================================

  onSearchFormSubmit(e) {
    const $target = $(e.currentTarget);
    const $input = $target.find('.js-search-input');
    const value = $input.val();

    e.preventDefault();
    console.log('SEARCH SUBMIT');
    this.state.searchKeysPressed = 0;
    this.state.currentSearch = value;
    // $input.blur();
  }

  //===========================================================================
  // Resets the search bar on history changes
  //===========================================================================

  resetSearch() {
    const $input = $('.js-header .js-search-input');
    const $results = $('.js-header-search-results');

    this.state.currentSearch = '';
    this.state.searchKeysPressed = 0;
    $input.val('');
    $results.empty();
  }

  //===========================================================================
  // Sets up the animation
  //===========================================================================

  setupAnimation() {
    const $body = $('body');

    setTimeout(() => {
      $body.removeClass('animation-start');
    }, 1000);
  }

  //===========================================================================
  // Hides the intro animation
  //===========================================================================

  removeIntroAnimation() {
    if (this.state.hasIntroAnimation) {
      const $html = $('html');
      const $body = $('body');
      const $animation = $body.find('.js-header-animation');

      $html.addClass('no-scroll');
      $body.removeClass('intro-screen');
      this.state.hasIntroAnimation = false;
      this.addAnimationToken();

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);

      setTimeout(() => {
        this.updateHeaderPadding();
        $html.removeClass('no-scroll');
        $body.removeClass('animation-hold')
        this.destroyIntroVideo($animation);
      }, 2500);
    }
  }

  //===========================================================================
  // Destroys the animation and video
  //===========================================================================

  destroyIntroVideo($animation) {
    $animation.find('video').each((i, video) => {
      if (video) {
        video.pause();
        video.removeAttribute('src'); // empty source
        video.load();
      }
    });

    setTimeout(() => {
      $animation.remove();
    }, 1000);
  }

  //===========================================================================
  // Checks if the intro animation can be used.
  //===========================================================================

  checkForValidAnimation() {
    const animationEl = document.querySelector('.js-header-animation');
    const sessionToken = window.sessionStorage.getItem('introAnimationDisplayed');

    if (!!animationEl && !sessionToken) {
      this.state.hasIntroAnimation = true;
    } else if (!!animationEl) {
      this.destroyIntroVideo($(animationEl));
    }
  }

  //===========================================================================
  // Adds the animation sessionStorage token
  //===========================================================================

  addAnimationToken() {
    window.sessionStorage.setItem('introAnimationDisplayed', true);
  }

  //===========================================================================
  // Removes the animation sessionStorage token
  //===========================================================================

  removeAnimationToken() {
    window.sessionStorage.removeItem('introAnimationDisplayed');
  }

  moveSubmenuToFirstColumn() {
    const firstColumn = document.querySelector('.header--submenu-links-wrapper');
    const submenu = document.querySelector('.js-add-to-first-column');

    if (firstColumn && submenu) firstColumn.append(submenu);
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-hamburger', this.toggleMobileMenu.bind(this));
    $(document).on('click', '.js-search-toggle', this.onHeaderSearchClick.bind(this));
    $(window).on('resize', this.updateHeaderPaddingOnResize.bind(this));
    $(window).on('resize', this.adjustHeaderOnScroll.bind(this));
    $(window).on('scroll', this.adjustHeaderOnScroll.bind(this));
    $(document).on('historyChange', this.reset.bind(this));

    // $(document).on('focusin', '.js-header .js-search-input, .js-header .js-search-submit', this.toggleSearchHoldOpen.bind(this));
    // $(document).on('focusout', '.js-header .js-search-input, .js-header .js-search-submit', this.toggleSearchHoldOpen.bind(this));
    // $(document).on('keydown', '.js-header .js-search-input', this.searchSubmit.bind(this));

    if (this.state.hasIntroAnimation) {
      $(document).on('click', 'body.animation-hold .js-header-search', this.removeIntroAnimation.bind(this));
      $(document).on('click', 'body.animation-hold .js-header-link', this.addAnimationToken.bind(this));
      $(document).on('click', '.js-header-animation', this.removeIntroAnimation.bind(this));
      $(window).on('scroll', this.removeIntroAnimation.bind(this));
    }

    if (this.state.hasHeaderSearchResults) {
      $(document).on('keyup', '.js-header-search-form .js-search-input', this.getSearchResultsOnInput.bind(this));
      $(document).on('submit', '.js-header-search-form', this.onSearchFormSubmit.bind(this));
    }

    document.addEventListener('DOMContentLoaded', () => { this.moveSubmenuToFirstColumn() });
    document.addEventListener('shopify:section:load', () => { this.moveSubmenuToFirstColumn() });
  }
}
